<template>
    <form class="form-container" @submit.prevent="submitForm">
        <div class="form-fields">
            <div class="input-container">
                <input
                    id="objet-input"
                    v-model="objetValue"
                    class="object-input"
                    name="objet"
                    required
                    type="text"
                    @blur="toggleObjetFocus(false)"
                    @focus="toggleObjetFocus(true)"
                />
                <label :class="objetValue || objetFocus ? 'active-label' : ''" class="label" for="objet-input">{{
                    $t('app.ask.estimate.subject')
                }}</label>
            </div>
            <div class="input-container description-container">
                <textarea
                    id="descriptif"
                    v-model="descriptifValue"
                    class="description-input"
                    cols="30"
                    maxlength="4000"
                    minlength="50"
                    name="descriptif"
                    required
                    rows="7"
                    @blur="toggleDescriptionFocus(false)"
                    @focus="toggleDescriptionFocus(true)"
                />
                <label
                    :class="descriptifValue || descriptionFocus ? 'active-label' : ''"
                    class="label"
                    for="descriptif"
                    >{{ $t('app.ask.estimate.description') }}</label
                >
                <ReglePastille cle="demandeDevis.descriptionMinimale" />
                <span v-if="remainingDescriptionCharacterCount > 0" class="character-counter">
                   {{ $t('app.ask.estimate.remainingCharacters') }} {{ remainingDescriptionCharacterCount }}
                </span>
            </div>
            <div class="date-wrapper">
                <DatePicker
                    :dateMin="today"
                    :dateValue="dateValue"
                    :label="$t('app.ask.estimate.date')"
                    @setDate="setDate"
                />
                <ReglePastille cle="demandeDevis.dateSouhaitee" />
            </div>
        </div>
        <div class="documents-wrapper">
            <AddDocuments :documents="files" @add="addFile" @remove="removeFile" />
            <ReglePastille cle="demandeDevis.piecesJointes" />
        </div>
    </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ESTIMATE } from '../store/mutation-types';
import fr from 'date-fns/locale/fr';
import AddDocuments from '@/modules/Common/components/AddDocuments.vue';
import DatePicker from '@/components/ui-components/DatePicker.vue';
import dayjs from 'dayjs';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    data() {
        return {
            objetFocus: false,
            descriptionFocus: false,
        };
    },
    components: { AddDocuments, DatePicker, ReglePastille },
    beforeMount() {
        // this.$store.state.estimateRequestState.documents = this.$store.state.estimateRequestState.documents ?? [];
    },
    setup() {
        return fr;
    },
    name: 'EstimateForm',
    computed: {
        objetValue: {
            get() {
                return this.$store.getters.getObjetValue;
            },
            set(value: string) {
                this.$store.commit(ESTIMATE.SET_OBJET, value);
            },
        },
        descriptifValue: {
            get() {
                return this.$store.getters.getDescriptifValue;
            },
            set(value: string) {
                this.$store.commit(ESTIMATE.SET_DESCRIPTIF, value);
            },
        },
        dateValue() {
            return this.$store.getters.getDateValue;
        },
        calendarIcon() {
            return require('@/assets/img/calendar.svg');
        },
        files() {
            return this.$store.getters.getEstimateFiles;
        },
        today() {
            return dayjs().format('YYYY-MM-DD');
        },
        remainingDescriptionCharacterCount(): number {
            return Math.max(50 - this.descriptifValue.length, 0);
        },
    },
    methods: {
        toggleObjetFocus(value: boolean) {
            this.objetFocus = value;
        },
        toggleDescriptionFocus(value: boolean) {
            this.descriptionFocus = value;
        },
        removeFile(file: File) {
            this.$store.commit(ESTIMATE.REMOVE_FILE, file);
        },
        addFile(file: File) {
            this.$store.commit(ESTIMATE.ADD_FILE, file);
        },
        setDate(date: string) {
            this.$store.commit(ESTIMATE.SET_DATE, date);
        },
    },
});
</script>

<style scoped>
.form-container {
    display: flex;
    width: 80%;
}
.form-fields {
    gap: 12px;
    padding-right: 90px;
    display: flex;
    flex-direction: column;
    width: 50%;
    border-right: 1px solid var(--medium-dark-grey);
}
.input-container {
    height: 16px;
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
}
.description-container {
    height: 150px;
}
.character-counter {
    position: absolute;
    right: 12px;
    bottom: 6px;
    color: var(--medium-dark-grey);
    font-size: var(--font-size-very-small);
}
.label,
.label-date {
    left: 12px;
    position: absolute;
    pointer-events: none;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    top: 8px;
    font-size: var(--font-size-low-medium);
    cursor: text;
}
.label-date {
    left: 36px;
}
.active-label {
    left: 12px;
    top: -8px;
    font-size: var(--font-size-very-small);
}
input,
textarea {
    border: none;
    outline: none;
    flex: 1;
    color: var(--black);
}
textarea {
    resize: none;
    height: 100%;
}
.icon {
    margin: 0;
    height: 24px;
    width: 24px;
    justify-self: end;
    cursor: pointer;
}
.date-wrapper,
.documents-wrapper {
    display: contents;
}
</style>
